module.exports = __webpack_public_path__ + "media/images/pages/primary-toolkit/online_safety_through_primary_computing-da2e52cd67e97b734f4fae155c2413a5.jpeg";